import Link from '@/components/atoms/Link';
import ModuleProducts from '@/utils/functions/Modules/products';
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import parse from 'html-react-parser';
//import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import CategoryIllustration from './AccordianCategoryShapesIllustration';
import React from 'react';
 
export default function AccordianIllustrationCard({
    item,
    division_info,
}: any) {
    const i = 1;
    const theme = useTheme();
    const { node } = item;
    //const router = useRouter();
    const [hover, setHover] = useState(false);
    const [desktopCols, setDesktopCols] = useState<number | null>(null);
    const [mobileCols, setMobileCols] = useState<number | null>(null);
    const [shape, setShape] = useState<any>(null);
    const [url, setUrl] = useState(null);
    
   

    useEffect(() => {
        if(node){
            if (node?.shapeIllustration) {
                setShape(JSON.parse(node?.shapeIllustration));
                if (division_info?.foamiteSettings) {
                    const { categoryColumnDesktop, categoryColumnMobile } =
                        division_info.foamiteSettings.shapesSettings;
    
                    setDesktopCols(parseFloat(categoryColumnDesktop));
                    setMobileCols(parseInt(categoryColumnMobile));
                }
            }
           
            let url = node.link;
           
            setUrl(url);
        }
        
    }, [item]);

    return (
        <Box
            //data-aos={'fade-up'}
            //data-aos-delay={i * 100}
            // data-aos-offset={100}
            // data-aos-duration={600}
            sx={{
                height: '100%',
            }}
        >
             
            <Card
                sx={{
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                    border: `1px solid ${theme.palette.divider}`,
                    '&:hover': {
                        transition: 'background-color 0.5s ease',
                        backgroundColor: 'common.white',
                        boxShadow: theme.shadows[1],
                    },
                    height: '100%',
                }}
            >
                <Box
                    component={Link}
                    href={url || '#;'}
                    sx={{
                        color: 'text.primary',
                        textDecoration: 'none !important',
                        cursor: 'pointer',
                        backgroundColor: 'transparent',
                        
                    }}
                >
                    <Box
                        sx={{
                            padding: 2,
                            '&:hover': {
                                color: theme.palette.common['headingGreen'],
                            },

                            color: 'text.secondary',
                            border: `1px solid ${theme.palette.divider}`,
                            height: '100%',
                        }}
                        onMouseEnter={(e) => setHover(true)}
                        onMouseLeave={(e) => setHover(false)}
                    >
                        <Box
                            width={1}
                            height={1}
                            data-aos={'fade-up'}
                            data-aos-delay={i * 100}
                            data-aos-offset={100}
                            data-aos-duration={600}
                        >
                            <Box
                                display={'flex'}
                                flexDirection={'column'}
                                alignItems={'center'}
                                justifyContent={'center'}
                            >
                                <CategoryIllustration
                                    images={shape?.images}
                                    hover={hover}
                                />
                                <Typography
                                    variant={'subtitle1'}
                                    gutterBottom
                                    fontWeight={700}
                                    align={'center'}
                                    sx={{
                                        textDecoration: 'none !important',
                                    }}
                                >
                                    {shape && parse(shape?.label)}
                                </Typography>
                                {shape?.below_label && (
                                    <Typography
                                        align={'center'}
                                        color="text.secondary"
                                        
                                    >
                                        {parse(shape?.below_label)}
                                    </Typography>
                                )}
                                {shape?.sub_label && (
                                    <Typography
                                        align={'center'}
                                        color="text.secondary"
                                        marginTop={0.5}
                                    >
                                        {parse(shape?.sub_label)}
                                    </Typography>
                                )}
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Card>
        </Box>
    );
}
